import { useState } from 'react'

export type StateArtProps = {
  /** An id from docs/ASSETS.md, never a path. */
  id: string
}

/**
 * The picture on a loading, empty, error or not found screen (POL-13). It draws the real file
 * the art pipeline wrote and simply steps aside if that file is ever missing, because a tinted
 * rectangle standing in for art is exactly what POL-16 bans.
 */
export function StateArt({ id }: StateArtProps) {
  const [missing, setMissing] = useState(false)
  if (missing) return null
  return (
    <img
      className="state__art"
      src={`/assets/${id}.webp`}
      alt=""
      aria-hidden="true"
      draggable={false}
      onError={() => setMissing(true)}
    />
  )
}
